import React from 'react';
import { Link } from 'react-router-dom';

const TradingPairList = props => {
    if (!props.tradeAnalysis) {
        return (
            <div className='broad'>Loading...</div>
        );
    }

    if (props.tradeAnalysis.trading_pairs.length === 0) {
        return (
            <div className='empty'>
                No trades...
      </div>
        );
    }

    return (
        <div>
            <table className="accountsTable">
                <thead>
                    <tr>
                        <th>Symbol</th>
                        <th>Bought</th>
                        <th>Average price bought</th>
                        <th>Sold</th>
                        <th>Average price sold</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.tradeAnalysis.trading_pairs.map(item => {
                            return (
                                <tr key={item.tradingpair}>
                                    <td>{item.tradingpair}</td>
                                    <td>{item.bought}</td>
                                    <td>{item.average_price_bought}</td>
                                    <td>{item.sold}</td>
                                    <td>{item.average_price_sold}</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    );
};

export default TradingPairList;



// WEBPACK FOOTER //
// ./src/components/widgets/TradingPairList.js